import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import ExtensionIcon from '@material-ui/icons/Extension';
import { rootRouteRef } from './routes';

const platformCapabilitiesPage = PageBlueprint.make({
  params: {
    path: '/platform-capabilities',
    routeRef: rootRouteRef,
    title: 'Platform Capabilities',
    icon: <ExtensionIcon />,
    noHeader: true,
    loader: async () => {
      const { PlatformCapabilitiesPage } = await import(
        './PlatformCapabilitiesPage'
      );
      return <PlatformCapabilitiesPage />;
    },
  },
});

export const platformCapabilitiesPlugin = createFrontendPlugin({
  pluginId: 'platform-capabilities',
  routes: {
    root: rootRouteRef,
  },
  extensions: [platformCapabilitiesPage],
});
